import {createSelector} from '@reduxjs/toolkit';

const auth = (state : any) => state.auth;

export const selectAuth = createSelector(auth, authSelect => authSelect);
